import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    launchedVsConfirmed(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/launched-vs-confirmed', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    workplacePendingActivations(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/workplace/pending-activations', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    activate(ctx, data) {
      return new Promise((resolve, reject) => {
        const { workplace_id: id, ...payload } = data
        axios
          .put(`/workplace/${id}/activate`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    activateWorkplace(ctx, data) {
      return new Promise((resolve, reject) => {
        const { workplace_id: id, ...payload } = data
        axios
          .put(`/workplace/${id}/activate`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    launchedVsConfirmedExport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/launched-vs-confirmed-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadPayroll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/payroll-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatePhysicianCompany(ctx, params) {
      return new Promise((resolve, reject) => {
        const { id, ...data } = params
        axios
          .put(`/workplace-physician-company/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    approvePhysician(ctx, params) {
      return new Promise((resolve, reject) => {
        const { physician_id: id, ...data } = params
        const formData = new FormData()
        if (data.file) formData.append('file', data.file, data.file.name)
        formData.append('justification', data.justification)
        formData.append('name', data.name)
        formData.append('changes', data.changes)
        formData.append('change_name', data.change_name ? 1 : 0)
        axios
          .post(`/physician/${id}/manual-approval`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    workplacePhysicianCompanyPending(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/workplace-physician-company/list-pending', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getPhysicianMotiveFile(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/uploaded-file/${params.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    paymentRemittanceExportDeleteHistory() {
      return new Promise((resolve, reject) => {
        axios
          .get('/payment-remittance/export-delete-history', { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    canceledAdvancedHistory() {
      return new Promise((resolve, reject) => {
        axios
          .get('/contract/canceled-advanced-history-export', { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianFirstAdvance(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/user-physician-first-advance', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDownloadPhysicianFirstAdvance(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/user-physician-first-advance-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicianActivate(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/physician-user-activate', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDownloadPhysicianActivate(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/physician-user-activate-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReportPhysicians(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/physician/report-crated-at', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadReportPhysicians(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/physician/report-crated-at-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadReport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/advanced-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadContract(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/contract/pdf/${queryParams.id}`, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/advanced', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportPaymentVoucher(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/contract/export-payment-voucher/${queryParams.contractId}`, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    payroll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/payroll', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    payrollDaily(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/payroll-by-day', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchConflicts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/physician-duty-conflict', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchWorkplaceByInstitution(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/workplace/list-by-institution', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReportContracts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/accountability', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReportContractsExport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/accountability-export', { params: queryParams, responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchPhysicians(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/physician/report-admin-all', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchInstitutions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/institution', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReportNeedValidatePhysicians(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/physician/report-need-validate-manually', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchReportNeedValidateHistoryPhysicians(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/physician-release-log', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProfitReport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/profit-report', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportProfitReport(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/admin-report/profit-report-xls', { responseType: 'blob', params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
